import React from 'react'
import './section-info-promo-expired.scss';
import Redirect from '../../../shared/components/atoms/redirect/redirect';
import ListRichText from '../../atoms/list-rich-text/list-rich-text';
import GalleryCarrousel from '../../atoms/gallery-carrousel/gallery-carrousel';
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import iconArrow from '../../../shared/assets/images/icons/icon-arrow-left.svg';
import parseFecha from '../../../shared/utils/parseFecha';
import SharedSocial from '../../atoms/shared-social/shared-social';
import siteUrl from '../../../shared/utils/siteUrl';
import SliderBannerGalery from '../../../shared/components/atoms/slider-galery/slider-banner-galery';
import iconDataTime from '../../../shared/assets/images/icons/data-time.svg';
import iconAlert from "../../../shared/assets/images/icons/pic-megaphone.svg";

import { useState, useEffect } from 'react';

const SectionInfoPromoExpired = props => {
    const { promo } = props;
    const { fechaDeInicio, fechaDeFin, textoCuandoExpire, textoDelBotonCuandoExpire, slugBotonCuandoExpire } = promo;
    const [expired, setExpired] = useState(false)
    
    let fechaS = fechaDeFin.split("-")
    let fechaFinFormat = new Date(`${fechaS[1]}/${fechaS[2]}/${fechaS[0]}`)
    let today = new Date()
    let todayFormat = new Date(`${today.getMonth()+1}/${today.getDate()}/${today.getFullYear()}`)
    
    useEffect(() => {
        HandleExpired()
    }, [])
    
    const HandleExpired = () => {              
       if(fechaFinFormat < todayFormat){
            setExpired(true)
       }      
    }
    
    const backLink = () => ( 
        <Redirect url="promociones/" className="link back-button">
            <img src={ iconArrow } alt="icon back"></img>
            <span>Volver</span>
        </Redirect> 
    )   
    

    return (
        <div className="o-section-info-promo-expired">
            <div className="o-section-promo-expired_breadcrumb">
                <Breadcrumb />
            </div>
            <div className="o-section-info-promo-expired-info">
                <img
                className="o-section-info-promo-expired-info-icon"
                src={iconAlert}
                />
                <h1 className="o-section-info-promo-expired-info-text">
                  {textoCuandoExpire}
                </h1>
                <Redirect url={slugBotonCuandoExpire} className="button back-button">
                <span>{textoDelBotonCuandoExpire}</span>
                </Redirect>
            </div>
        </div>
    )
}

export default SectionInfoPromoExpired
